"use client";

import React from "react";

export default function DisclaimerPage() {
  return (
    <main className="min-h-screen bg-white">
      {/* HEADER SECTION */}
        <div className="bg-[#fafafa] pt-32 pb-20 px-6 border-b border-neutral-100">
          <div className="max-w-[800px] mx-auto text-center">
            <span className="text-[11px] font-bold text-[#c8a96e] uppercase tracking-[0.3em] block mb-2">
              Legal Information
            </span>
            
            <h1 className="text-4xl md:text-5xl font-serif italic text-[#121826] mt-4">
              Disclaimer Policy
            </h1>
            
            <div className="w-16 h-[1.5px] bg-[#c8a96e] mx-auto mt-6"></div>
          </div>
        </div>

      {/* CONTENT SECTION */}
      <section className="max-w-[800px] mx-auto py-16 px-6 md:py-24">
        <div className="space-y-12 text-[#444] leading-[1.8] font-light">
          
          <p className="text-lg text-[#121826] font-medium italic">
            At Modish Kreations, we strive to ensure that all information and recommendations related to our products, services, designs, and content provided on this website are accurate and up to date.
          </p>

          {/* GENERAL DISCLAIMER */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#121826] flex items-center gap-3">
              <span className="w-6 h-[1px] bg-[#c8a96e]"></span>
              General Disclaimer
            </h2>
            <div className="pl-9 space-y-3">
              <p>Modish Kreations does not warrant that:</p>
              <ul className="list-disc pl-5 space-y-2 marker:text-[#c8a96e]">
                <li>The information, products, or services will fully meet your expectations or requirements.</li>
                <li>The website will function uninterrupted, timely, secure, or error-free.</li>
                <li>The website or its services will be accessible at all times or across all devices and platforms.</li>
              </ul>
              <p className="bg-[#faf8f5] p-4 rounded-lg border-l-4 border-[#c8a96e] text-sm italic">
                All information and services are provided on an “as-is” basis, and users are advised to independently verify suitability.
              </p>
            </div>
          </div>

          {/* LIMITATION OF LIABILITY */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#121826] flex items-center gap-3">
              <span className="w-6 h-[1px] bg-[#c8a96e]"></span>
              Limitation of Liability
            </h2>
            <div className="pl-9 space-y-3">
              <p>Any use of this website or reliance on the information provided is at the user’s own risk.</p>
              <p>Modish Kreations, its affiliates, or representatives shall not be held liable for losses arising from:</p>
              <ul className="list-disc pl-5 space-y-2 marker:text-[#c8a96e]">
                <li>Use or inability to access the website.</li>
                <li>Reliance on any information provided.</li>
                <li>Third-party links or external websites connected to our platform.</li>
              </ul>
            </div>
          </div>

          {/* PRODUCT DISCLAIMER */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#121826] flex items-center gap-3">
              <span className="w-6 h-[1px] bg-[#c8a96e]"></span>
              Product Disclaimer (Color & Description)
            </h2>
            <div className="pl-9 space-y-3">
              <ul className="list-disc pl-5 space-y-2 marker:text-[#c8a96e]">
                <li>Product specifications and descriptions are approximate and may vary slightly.</li>
                <li>Actual product colors may differ due to screen settings, lighting, or device variations.</li>
                <li>Minor variations in fabric, texture, or design are a natural part of handcrafted and bespoke products.</li>
              </ul>
            </div>
          </div>

          {/* HANDLING & TRANSPORTATION */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#121826] flex items-center gap-3">
              <span className="w-6 h-[1px] bg-[#c8a96e]"></span>
              Handling & Transportation Disclaimer
            </h2>
            <div className="pl-9 space-y-3">
              <p>
                Due to shipping and handling, minor embellishments (such as beads or decorative elements) may occasionally loosen or come off. Such instances are rare but may occur due to external factors beyond our control.
              </p>
            </div>
          </div>

          {/* FINAL NOTE */}
          <div className="pt-10 border-t border-neutral-100 text-center">
            <div className="inline-block bg-[#121826] text-white px-8 py-4 rounded-full text-sm tracking-widest uppercase font-bold">
              Final Note
            </div>
            <p className="mt-6 text-sm text-neutral-500 max-w-[600px] mx-auto italic">
              By using this website, you acknowledge and agree to this disclaimer policy. At Modish Kreations, we remain committed to delivering quality products while maintaining transparency and trust.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
}